<template>
  <section class="pa-flash-message">
    <transition name="pa-simple-fade" @enter="handleBeforeEnter">
      <div class="flash-message" :class="flashMessageClass" v-if="isShow">
        <div class="content-set content" ref="contentField">
          <div class="content-inner" ref="contentInner">
            <font-awesome-icon :icon="messageIcon" />
            <span v-html="messageText"></span>
          </div>
        </div>
        <div class="overlay content-set content-overlay" ref="contentOverlay">&nbsp;</div>

        <div class="button-set button-text" ref="buttonText">
          <template v-if="isControllable">
            <button class="close" @click.prevent="handleClickClose">-&nbsp;close&nbsp;-</button>
          </template>
          <template v-else>
            {{controlButtonText}}
          </template>
        </div>
        <div class="overlay button-set button-overlay" ref="buttonOverlay">&nbsp;</div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name : 'PAFlashMessage',
  props : {
    hasFlashMessage : {
      default : false,
    },

    message   : {
      default : '',
    },

    status    : {
      default : 'default',
    },

    hasControl : {
      default  : false
    },

    autoClose  : {
      default  : false,
    }
  },
  data(){
    return {
      isShow                : false,
      isAutoClose           : false,
      isControllable        : false,

      messageStatus         : 'primary',
      messageIcon           : 'info-circle',
      messageText           : 'これはFlashMessageです。',
      controlButtonText     : 'アプリを再読込してください。',
      
      controlButtonTemplate : {
        reload    : 'アプリを再読込してください。',
        auto      : 'このフィールドは自動的に消えます。',
        close     : '-&nbsp;close&nbsp;-',
      },

      flashMessageClass   : [],

      autoCloseTimeoutId  : null,
    };
  },
  watch : {
    // ===== Props -> data ===== //
    hasFlashMessage : {
      handler(value){
        this.isShow = value;
      },
      immediate: true
    },

    message         : {
      handler(value){
        this.messageText = value;
      },
      immediate: true
    },

    status          : {
      handler(value){
        this.messageStatus = value;
      },
      immediate: true
    },

    hasControl      : {
      handler(value){
        this.isControllable = value;
      },
      immediate: true
    },
    
    autoClose       : {
      handler(value){
        this.isAutoClose = value;
      },
      immediate: true
    },
    // ===== Props -> data [END] ===== //

    isShow          : {
      handler(value){
        if(value === true){
          this.checkButtonBehabiour();
          this.checkAutoClose();
        }
      },
      immediate: true
    },

    messageStatus   : {
      handler(){
        this.changeStatus();
      },
      immediate: true
    },
    
  },
  methods : {
    checkButtonBehabiour(){
      if( !this.isControllable && (this.isAutoClose !== false) ){
        this.controlButtonText = this.controlButtonTemplate.auto;
      }

      if(!this.isControllable && (this.isAutoClose === false)){
        this.controlButtonText = this.controlButtonTemplate.reload;
      }
    },

    changeStatus(){
      switch(this.messageStatus){
        case 'info':
        case 'default':
          this.messageIcon        = 'info-circle';
          this.flashMessageClass  = ['flash-message-status-default'];
        break;

        case 'primary':
          this.messageIcon        = 'check-circle';
          this.flashMessageClass  = ['flash-message-status-primary'];
        break;
        
        case 'alert':
          this.messageIcon        = 'exclamation-triangle';
          this.flashMessageClass  = ['flash-message-status-alert'];
        break;

        case 'error':
          this.messageIcon        = 'exclamation-triangle';
          this.flashMessageClass  = ['flash-message-status-error'];
        break;

        case 'question':
        default:
          this.messageIcon        = 'question-circle';
          this.flashMessageClass  = ['flash-message-status-default'];
        break;
      }
    },
    
    checkAutoClose(){
      if(this.isAutoClose === false) return;
      if(this.isAutoClose === true) this.isAutoClose = 5000;

      this.autoCloseTimeoutId = setTimeout(() => {
        this.handleClickClose();
      }, this.isAutoClose);
    },
    
    resizedLayout(){
      if( (typeof this.$refs.contentInner === 'undefined') || (this.$refs.contentInner === null) ) return;

      const contentOffsetHeight = this.$refs.contentField.offsetHeight;

      this.$refs.contentOverlay.style.height  = contentOffsetHeight+'px';

      if( (typeof this.$refs.buttonText === 'undefined') && (this.$refs.buttonText === null) ) return;

      const buttonHeight = this.$refs.buttonText.offsetHeight;

      this.$refs.buttonText.style.top       = contentOffsetHeight+'px';
      this.$refs.buttonOverlay.style.top    = contentOffsetHeight+'px';
      this.$refs.buttonOverlay.style.height = buttonHeight+'px';
    },

    handleClickClose(){
      this.$emit('closed');
    },

    handleBeforeEnter(){
      this.resizedLayout();
    }
  },
  updated(){
    if(!this.hasFlashMessage) return;

    this.resizedLayout();
  },

  created(){
    window.addEventListener('resize', this.resizedLayout);
  },

  beforeDestroy(){
    window.removeEventListener('resize', this.resizedLayout);
    
    if(this.autoCloseTimeoutId !== null){
      clearTimeout(this.autoCloseTimeoutId);
    }
  }

  // , mounted(){
  //   // // for Debugging
  //   // setTimeout(() => {
  //   //   this.isShow = true;
  //   //   this.isAutoClose = 10000;
  //   //   this.isControllable = true;
  //   // }, 1000);
  // }
}
</script>

<style lang="scss">
  section.pa-flash-message{
    div.flash-message{
      position: fixed;
      // z-index:20;
      z-index:299;
      width:100vw;
      top:0;
      left:0;
      cursor: default;

      .overlay{
        position: absolute;
        // z-index:20;
        z-index:299;
        top:0;
        left:0;
        width:100%;
      }

      .content-set, .button-set{
        position: absolute;
        // z-index:20;
        z-index:299;
        top:0;
        left:0;
        width:100%;
      }

      .content-set{
        &.content{
          // z-index: 21;
          z-index:300;

          .content-inner{
            width:95%;
            margin:0 auto;
            font-size:1.1rem;
            line-height: 3;
            color:#fafafa;
            text-align: center;
            user-select: none;

            svg{
              margin-right: .3rem;
            }
          }
        }
        
        &.content-overlay{
          background-color: #212121;
          opacity: .85;
        }
      }

      .button-set{
        position: absolute;
        // z-index:21;
        z-index:300;
        top:0;
        left:0;
        width:100vw;
        border-top:1px solid #333333;

        &.button-text{
          color:#8A8A8A;
          font-size:.7rem;
          padding:.1rem 0;
          user-select: none;
          text-align:center;
        }

        &.button-overlay{
          // z-index:20;
          z-index:299;
          background-color: #212121;
          opacity: .92;
        }

        button.close{
          display:block;
          border:0;
          margin:0;
          padding:0;
          background-color: inherit;
          width:100%;
          font-weight: bold;
          color:#ffffff;
          font-size:.7rem;
          cursor: pointer;
        }
      }

      &-status{
        &-default{
          .content-set{
            &.content{
              .content-inner{
                color: #fafafa;
              }
            }

            &.content-overlay{
              background-color: #212121;
            }
          }

          .button-set{
            border-color:#333333;
            
            &.button-overlay{
              background-color: #212121;
            }
          }
        }

        &-primary{
          .content-set{
            &.content{
              .content-inner{
                color: #fafafa;
              }
            }

            &.content-overlay{
              background-color: #2A823D;
            }
          }

          .button-set{
            border-color:rgb(32, 107, 48);
            
            &.button-overlay{
              background-color: #2A823D;
            }
          }
        }

        &-alert{
          .content-set{
            &.content{
              .content-inner{
                color: #fafafa;
              }
            }

            &.content-overlay{
              background-color: #C69E3C;
            }
          }

          .button-set{
            border-color:rgb(177, 139, 42);
            
            &.button-overlay{
              background-color: #C69E3C;
            }
          }
        }

        &-error{
          .content-set{
            &.content{
              .content-inner{
                color: #fafafa;
              }
            }

            &.content-overlay{
              background-color: #8E1B52;
            }
          }

          .button-set{
            border-color: rgb(124, 22, 71);

            &.button-overlay{
              background-color: #8E1B52;
            }
          }
        }
      }
    }
  }
</style>